define((require) => {
    "use strict";

    const ImprovedModel = require("shared/zbone/ImprovedModel");
    const Configuration = require("shared/services/Configuration");

    /**
     * A product property model.
     *
     * @class ProductPropertiesModel
     * @constructor
     */
    return ImprovedModel.extend("ProductPropertiesModel", {

        _api: "productwidget",

        getProduct(productID, lang, companyid) {
            const url = Configuration.inventoryUrl;

            const urloptions = {
                silent: true,
                method: "get",
                type: "GET",
                url,
                data: {
                    cid: companyid,
                    lang: lang,
                    view: this._api,
                    ids: productID,
                    contentType: "application/json"
                }
            };

            return this.fetch(urloptions);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/dynamicProductWidget/ProductPropertiesModel.js